<div class="principalContainerPass">
  <div class="secondContainerPass">
    <div class="titlePass">
      <h3>¡Cambio de contraseña para {{currentCustomerName}}!</h3>
    </div>
    <div class="imagepass">
      <img src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/undraw/resetpassword.svg" alt="Imagen de Bienvenida">
    </div>
    <div class="bodyPass">
      <p>Vemos que necesitas un cambio de contraseña para mantener segura tu cuenta.</p>
      <p>Da click en el botón de abajo y se te enviará una nueva contraseña a tu correo electrónico.</p>
      <div class="buttonspass" *ngIf="!donePassword">
        <button class="mybtnfail" (click)="doPasswordChange()">Cambiar mi contraseña</button>
        <button class="mybtnok" (click)="cancelPasswordChange()">Ir al menú principal</button>
      </div>
    </div>
  </div>
</div>
